/**
 * A full page load at `path`, which drops every in-memory cache with it (React Query's, and the
 * zustand stores', which rehydrate from what was persisted). Used where the signed-in identity has
 * just changed underneath the app, so nothing fetched as the previous identity survives.
 *
 * Its own module so tests can replace it: jsdom does not implement navigation.
 */
export function hardNavigate(path: string) {
    window.location.href = path
}
